import React from 'react';

import Svg from '@styles/icons/svg';
import Button from '@styles/buttons';
import { ColorFunction } from '@styles/colors/types';

export default ({ C, onClick, zoomIcon, disabled, testID }: { C: ColorFunction; onClick: () => void; zoomIcon: string; disabled?: boolean; testID?: string }) => {
  return (
    <Button
      {...{
        variant: 'Icon Button',
        type: 'Icon Button',
        onPress: onClick,
        disabled,
        testID,
      }}
    >
      <Svg
        icon={zoomIcon}
        width={17}
        height={16}
        color={disabled ? 'Label/Light/Quinary' : 'Button/Light/Primary'}
        key={disabled ? 'disable-zoom' : 'active-zoom'}
      />
    </Button>
  );
};
